module.exports = "/_next/static/resources/life1-917254295776a236aa14924acec0c1db.jpg";